import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { UserRoleSchema } from '@repo/shared/schema';
import { UserRole } from '@repo/shared/types';
import { Button } from '@repo/ui/button';
import { Input } from '@repo/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@repo/ui/select';
import { Search, X } from 'lucide-react';
import { Activity } from 'react';
import z from 'zod';
import type { TTableFilters } from '@/types/table';

export const ZOfficersTableFiltersSchema = z.object({
  search: z.string(),
  role: z.union([UserRoleSchema, z.enum(['ALL'])]),
});
export type TOfficersTableFilters = z.infer<typeof ZOfficersTableFiltersSchema>;
export interface OfficersTableFiltersProps extends TTableFilters<TOfficersTableFilters> {}

export function OfficersTableFilters({
  filters,
  onFilterChange,
  onClearFilters,
  hasFilters,
}: OfficersTableFiltersProps) {
  useLocale();

  return (
    <div className="space-y-4">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute start-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            className="ps-9"
            onChange={(e) => onFilterChange('search', e.target.value)}
            placeholder={t('workspace.searchOfficersByNameOrEmail')}
            value={filters.search}
          />
        </div>
        <Select onValueChange={(value) => onFilterChange('role', value)} value={filters.role}>
          <SelectTrigger className="w-[140px]">
            <SelectValue placeholder={t('workspace.role')} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="ALL">{t('workspace.allRoles')}</SelectItem>
            <SelectItem value={UserRole.ORG_MANAGER}>{t('workspace.managerOfficer')}</SelectItem>
            <SelectItem value={UserRole.ORG_OFFICER}>{t('workspace.officer')}</SelectItem>
            <SelectItem value={UserRole.ORG_KYB_OFFICER}>{t('workspace.kybOfficer')}</SelectItem>
            <SelectItem value={UserRole.ORG_KYC_OFFICER}>{t('workspace.kycOfficer')}</SelectItem>
          </SelectContent>
        </Select>
        <Activity mode={hasFilters ? 'visible' : 'hidden'}>
          <Button onClick={onClearFilters} variant="outline">
            <X className="h-4 w-4" />
            {t('workspace.clearFilters')}{' '}
          </Button>
        </Activity>
      </div>
    </div>
  );
}
